import React, { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import classNames from 'classnames';
import Div from './Div';

/* Password Input */
const PasswordInput = ({ name, placeholder, refCallback, errors, register, className }) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <>
            <InputGroup className="mb-0">
                <Form.Control
                    type={showPassword ? 'text' : 'password'}
                    placeholder={placeholder}
                    name={name}
                    id={name}
                    as="input"
                    ref={(r) => {
                        if (refCallback) refCallback(r);
                    }}
                    className={className}
                    isInvalid={errors && errors[name] ? true : false}
                    {...(register ? register(name) : {})}
                    autoComplete={name}
                />
                <div
                    className={classNames('input-group-text', 'input-group-password', {
                        'show-password': showPassword,
                    })}
                    data-password={showPassword ? 'true' : 'false'}>
                    <span
                        className="password-eye"
                        onClick={() => {
                            setShowPassword(!showPassword);
                        }}></span>
                </div>
            </InputGroup>
        </>
    );
};

type FormInputProps = {
    label?: string;
    type?: string;
    name?: string;
    placeholder?: string;
    register?: any;
    value?: any;
    errors?: any;
    icon?: any;
    className?: string;
    labelClassName?: string;
    containerClass?: string;
    refCallback?: any;
    children?: any;
    multiple?: boolean;
    options?: any[];
    inline?: boolean;
};

const FormInput = ({
    label,
    type,
    icon,
    name,
    value,
    placeholder,
    register,
    errors,
    multiple,
    options,
    className,
    labelClassName,
    containerClass,
    refCallback,
    children,
    inline,
    ...otherProps
}: FormInputProps): React.ReactElement => {
    // handle input type
    const comp = type === 'textarea' ? 'textarea' : type === 'select' ? 'select' : 'input';

    return (
        <>
            {type === 'hidden' ? (
                <input type={type} name={name} {...(register ? register(name) : {})} {...otherProps} />
            ) : (
                <>
                    {type === 'password' ? (
                        <>
                            <Form.Group className={containerClass}>
                                    {
                                        label ? (
                                        <>
                                            {' '}
                                            <Form.Label className={labelClassName}>{label}</Form.Label> {children}{' '}
                                        </>
                                        ): null
                                    
                                         }
                                <PasswordInput
                                    name={name}
                                    placeholder={placeholder}
                                    refCallback={refCallback}
                                    errors={errors}
                                    register={register}
                                    className={className}
                                />

                                {errors && errors[name] ? (
                                    <Form.Control.Feedback type="invalid" className="d-block">
                                        {errors[name]['message']}
                                    </Form.Control.Feedback>
                                ) : null}
                            </Form.Group>
                        </>
                    ) : (
                        <>
                                    {type === 'checkbox' || type === 'radio' ? (
                                        <>
                                            <Form.Group className={containerClass}>
                                                <Form.Check
                                                    type={type}
                                                    label={
                                                        <Div className="ps-1">
                                                            {icon} {label}
                                                        </Div>
                                                    }
                                                    name={name}
                                                    id={name}
                                                    ref={(r) => {
                                                        if (refCallback) refCallback(r);
                                                    }}
                                                    value={value}
                                                    className={className}
                                                    isInvalid={errors && errors[name] ? true : false}
                                                    {...(register ? register(name) : {})}
                                                    {...otherProps}
                                                />

                                                {errors && errors[name] ? (
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors[name]['message']}
                                                    </Form.Control.Feedback>
                                                ) : null}
                                            </Form.Group>
                                        </>
                                    ) :  type === 'select' ?
                                            <Form.Group className={containerClass}>
                                                {inline && label ? (
                                                    <div className="d-flex align-items-center gap-2">
                                                        <span className={labelClassName}>{label}</span>
                                                        <Form.Control
                                                            type={type}
                                                            placeholder={placeholder}
                                                            name={name}
                                                            id={name}
                                                            as={comp}
                                                            ref={(r) => {
                                                                if (refCallback) refCallback(r);
                                                            }}
                                                            multiple={multiple}
                                                            className={className}
                                                            isInvalid={errors && errors[name] ? true : false}
                                                            {...(register ? register(name) : {})}
                                                            {...otherProps}
                                                            autoComplete={name}>
                                                            {options ? options.map((o) => { return <option key={o.value} value={o.value}>{o.text}</option> }) : null}
                                                        </Form.Control>
                                                    </div>
                                                ) : (
                                                    <>
                                                        {label ? <Form.Label className={labelClassName}>{label}</Form.Label> : null}
                                                        <Form.Control
                                                            type={type}
                                                            placeholder={placeholder}
                                                            name={name}
                                                            id={name}
                                                            as={comp}
                                                            ref={(r) => {
                                                                if (refCallback) refCallback(r);
                                                            }}
                                                            multiple={multiple}
                                                            className={className}
                                                            isInvalid={errors && errors[name] ? true : false}
                                                            {...(register ? register(name) : {})}
                                                            {...otherProps}
                                                            autoComplete={name}>
                                                            {options ? options.map((o) => { return <option key={o.value} value={o.value}>{o.text}</option> }) : null}
                                                        </Form.Control>
                                                    </>
                                                )}

                                                {errors && errors[name] ? (
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors[name]['message']}
                                                    </Form.Control.Feedback>
                                                ) : null}
                                                </Form.Group>
                                    : (
                                        <Form.Group className={containerClass}>
                                            {label ? <Form.Label className={labelClassName}>{label}</Form.Label> : null}

                                            <Form.Control
                                                type={type}
                                                placeholder={placeholder}
                                                name={name}
                                                id={name}
                                                as={comp}
                                                ref={(r) => {
                                                    if (refCallback) refCallback(r);
                                                }}
                                                className={className}
                                                isInvalid={errors && errors[name] ? true : false}
                                                {...(register ? register(name) : {})}
                                                {...otherProps}
                                                autoComplete={name}>
                                                {children ? children : null}
                                            </Form.Control>

                                            {errors && errors[name] ? (
                                                <Form.Control.Feedback type="invalid">
                                                    {errors[name]['message']}
                                                </Form.Control.Feedback>
                                            ) : null}
                                        </Form.Group>
                                    )}
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default FormInput;
